var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.sessionReady
        ? [
            !_vm.assessment
              ? _c(
                  "ContentViewer",
                  _vm._g(
                    _vm._b(
                      { staticClass: "content-viewer" },
                      "ContentViewer",
                      _vm.contentProps,
                      false
                    ),
                    _vm.contentHandlers
                  )
                )
              : _c(
                  "AssessmentWrapper",
                  _vm._g(
                    _vm._b(
                      { staticClass: "content-viewer" },
                      "AssessmentWrapper",
                      _vm.exerciseProps,
                      false
                    ),
                    _vm.contentHandlers
                  )
                ),
          ]
        : _c("KCircularLoader"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }